import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var EmojiSlightlyHappyIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11zm0-2a9 9 0 110-18 9 9 0 010 18zm-.1-3c-2.798 0-4.8-1.564-5.794-3.553a1 1 0 111.788-.894C8.58 14.923 9.958 16 11.9 16c2.11 0 3.514-1.064 4.205-2.447a1 1 0 011.79.894C16.89 16.454 14.85 18 11.9 18zM8 10.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM17.5 9a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z",
                        fillRule: "evenodd",
                        clipRule: "evenodd"
                    })
                })
            })
        ]
    });
};
EmojiSlightlyHappyIcon.isCarinaIcon = true;
export default EmojiSlightlyHappyIcon;
